var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('a',{attrs:{"href":"https://rightcloud.pl"}},[_vm._v("made by rightcloud")])])
}]

export { render, staticRenderFns }